// extracted by mini-css-extract-plugin
module.exports = {"container":"bottomMenu_container__3Fz-q","itemActive":"bottomMenu_itemActive__2JSfv","itemImg":"bottomMenu_itemImg__3TOSz"};